import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { HOME_MAIN_PAGE_PATH } from "utils/constants/paths";

const HomeMainPage = Loadable(React.lazy(() => import("./View")));

export const homeMainPageRoute: IRouteItem = {
  path: HOME_MAIN_PAGE_PATH,
  element: React.createElement(HomeMainPage),
  name: "Home Main Page",
};
